import { StackedCellText } from '@/components/common/DataTable';
import { HighlightText } from '@/components/common/HighlightText';

interface PersonNameCellProps {
  name: string;
  designationName: string | null;
  mobile: string | null;
  note?: string | undefined;
  searchText: string | undefined;
}

export function PersonNameCell({
  name,
  designationName,
  mobile,
  note,
  searchText,
}: PersonNameCellProps) {
  return (
    <StackedCellText
      primary={<HighlightText text={name} highlightedText={searchText} />}
      primaryClassName="font-medium"
      secondary={designationName}
      tertiary={mobile && <HighlightText text={mobile} highlightedText={searchText} />}
      quaternary={note}
    />
  );
}
